import React, {PropTypes} from 'react';
import {reduxForm} from 'redux-form';
import RaisedButton from 'material-ui/RaisedButton';
import {Input} from '../../../form';
import ImageUploadWithErrorContainer from '../../../form/ImageUpload/ImageUploadWithErrorContainer'
import {DetailsEdit} from './DetailsEdit';
import {FullPageDialog} from '../../../common/FullPageDialog';

import {validateRedux} from '../../../../utilites/validate';

const validate = (data) => {
  let validationRules = {
    primaryText: {
      presence: true
    },
    avatar: {
      presence: {message: '^Please upload an image'}
    }
  };
  return validateRedux(data, validationRules);
};

export class ListItemEditForm extends React.Component {
  static propTypes = {
    ImageClass: PropTypes.func.isRequired,
    imageCrop: PropTypes.object.isRequired,
    open: PropTypes.bool.isRequired,
    onSave: PropTypes.func.isRequired,
    onClose: PropTypes.func.isRequired
  };

  static defaultProps = {
    open: false
  };

  handleClose() {
    const {onClose, resetForm} = this.props;
    resetForm();
    onClose();
  }

  save(data) {
    const {onSave} = this.props;
    onSave(data);
    this.handleClose();
  }

  render() {
    const {open, ImageClass, imageCrop, fields: {
      primaryText,
      secondaryText,
      avatar,
      details
    }, handleSubmit} = this.props;
    return open ?
      (<FullPageDialog
        label="Edit List Item"
        open={open}
        onClose={() => this.handleClose()}
      >
        <div style={{width: '100%', maxWidth: 540}}>
        <ImageUploadWithErrorContainer label='Avatar' ImageClass={ImageClass} crop={imageCrop} {...avatar}/>
        <Input label='Primary Text' {...primaryText}/>
        <Input label='Secondary Text' {...secondaryText}/>
        <DetailsEdit {...details}/>

        <RaisedButton
          label="Done"
          secondary={true}
          onTouchTap={handleSubmit(data=>this.save(data))}
        />
        </div>
      </FullPageDialog>
      )
      : null;
  }
}

export const ListItemEditReduxForm = reduxForm(
  {
    form: '@club-cms/edit-list-item',
    fields: [
      'primaryText',
      'secondaryText',
      'avatar',
      'details'
    ],
    validate
  }
)(ListItemEditForm);


export default ListItemEditForm;



// WEBPACK FOOTER //
// ./src/components/ClubCMS/Content/ListContentComponent/ListItemEditForm.js